<template>
  <highlight-card
    :button="{ label: texts.photosCta }"
    :fact="photos.length ? null : { icon: 'customMedia', text: texts.photosHeading }"
    :heading="prompt ? texts.photosPrompt : texts.photosHeading"
    :image="!photos.length && image ? { ...image, cover: true } : null"
    :status="count"
    :text="sprintf(texts.photosText, deceasedName)"
    @action="addPhoto"
  >
    <template v-if="photos.length" #media>
      <div class="highlight-card__photos" :data-count="photos.length">
        <img
          alt=""
          decoding="async"
          loading="lazy"
          v-for="src in photos"
          :key="src"
          :src="src"
        >
      </div>
    </template>
  </highlight-card>
</template>

<script lang="ts" setup>
  import { quickContent } from "Plugins/obituary/javascript/composables/useSlideshow";
  import { MEDIA_INITIAL } from "Plugins/obituary/javascript/createCommentStepsHelper";
  import type { CardPhoto } from "Plugins/obituary/javascript/highlights/cards";
  import { highlightTexts } from "Plugins/obituary/javascript/highlights/texts";
  import { faceCropUrl } from "Plugins/obituary/javascript/slideshow/imgix";
  import {
    MIN_PHOTOS,
    mediaCount,
  } from "Plugins/obituary/javascript/slideshow/playlist";
  import { sprintf } from "sprintf-js";
  import { useStore } from "vuex";
  import HighlightCard from "../HighlightCard.vue";

  /** The media area fits this many: one large, two beside it. */
  const MAX_SHOWN = 3;

  /** `image` is the site's fallback, shown only while the page has no photos of its own. */
  defineProps<{ deceasedName: string; image?: CardPhoto }>();

  const store = useStore();
  const texts = highlightTexts();
  const content = quickContent();
  const total = content ? mediaCount(content) : 0;

  // Under MIN_PHOTOS there is no slideshow yet: invite, and show what there is.
  const prompt = total < MIN_PHOTOS;
  // There is no plural string, so "1 bilder och filmer" never shows.
  const count =
    !prompt && total > 1 ? sprintf(texts.photosCount, total) : undefined;
  const photos = [
    ...new Set((content?.media ?? []).filter((m) => m.src).map((m) => m.src)),
  ]
    .slice(0, MAX_SHOWN)
    .map((src) => faceCropUrl("", src, 640));

  function addPhoto() {
    store.dispatch("createComment/toggleModal", MEDIA_INITIAL);
  }
</script>
